import { Button } from "react-bootstrap"
import Link from "next/link"
import React , {useState,useRef,useEffect} from "react"
import { buildHref } from "~/utils"
import { routes } from "~/router"
import { withI18n } from "~/hocs"

const ListTag = ({ t, lng, tags, videoID }) => {
  const [showMore,setShowMore] = useState(false);
  const [divHeight, setDivHeight] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      setDivHeight(ref.current.clientHeight);
    }
  }, []);
  
  return (
    tags &&
    tags.length > 0 && (
      <div className={`video-item-tag ${showMore ? `` :`pr-5`} position-relative`}>
        <div className={`d-flex align-items-center flex-wrap overflow-hidden ${showMore ? `` :`max-height-68`} ac-pr-75`} ref={ref}>
          <span className="ac-mr-1 ac-mb-1">{t("tags")} :</span>
          {tags
            .filter((item) => item.name && item.name !== "")
            .map((item, idx) => (
              <Link
                href={buildHref({
                  pathname: routes.tag.href,
                  query: {
                    tag: item.name,
                  },
                  lng,
                })}
                key={idx}
              >
                <Button variant="ac-px-1 py-1 rounded-pill ac-bg-gray-10 ac-mr-1 ac-mb-1 border d-inline-block tag-dedail-item">
                  <small>{item.name}</small>
                </Button>
              </Link>
            ))}
            {
              showMore && <a className="ac-mb-1" style={{ color: '#1d74b3' }} onClick={()=>{setShowMore(false)}}>≪ 表示を減らす</a>
            }
            
            {
              !showMore && divHeight > 37 && tags.length > 26 && <a className="ac-mb-1 position-absolute" style={{ color: '#1d74b3',right: "1%" ,top:"51%" }} onClick={()=>{setShowMore(true)}}>全て表示 ≫</a>
            }
            
        </div>
        {/* <div>
        <div size="middle">
          {
            tags.map((item, idx) => (
              <Button variant="outline-secondary" key={idx}>{item.name}</Button>
              <div className="video-item-tag-item" key={idx}>
                <div >
                  <Image
                    src={item.preview_thumbnail}
                    width={30}
                    height={30}
                    // layout="fill"
                    objectFit="cover"
                    loading="eager"
                  />
                  <span>{item.name}</span>
                </div>
              </div>
            ))
          }
        </div>
      </div> */}
      </div>
    )
  )
}

export default withI18n(ListTag)
